import React, { Component } from 'react';
import {isMobile} from 'react-device-detect';

class Ticker extends Component {
  componentDidMount(){
    setTimeout(()=>{
      let ticker = document.getElementById('tickertape')
      if(ticker){
        let newDoc = document.createElement('div')
        newDoc.innerHTML = ticker.innerHTML
        if(document.getElementById("ticker-container")){
          document.getElementById("ticker-container").appendChild(newDoc);
          // newDoc.style.display = 'block';
          // ticker.parentNode.removeChild(ticker);
        }
      }
    },500)
  }
  render() {
    let style = {height:'40px',background:'rgb(10,10,10)'}

    if(isMobile){
      return (<></>)
    }
    else return (
      <div style={{opacity:this.props.display ? 1 : 0,pointerEvents:'none'}}>
        <div id='ticker-container' className='minWidth' style={style}>
        </div>
      </div>
    );
  }
}

export default Ticker;
